import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";
import GetConfigItem from "../../../../components/get-configs/get-config-item";
import LoadingSpinner from "../../../../components/global/loading-spinner";
import { useGetConfig } from "../../../../hooks/useGetConfig";

const useStyles = makeStyles((theme) => ({
  topBox: {
    color: "#000",
    padding: "16px 42px",
    lineHeight: "24px",
    borderRadius: "0 0 50px 50px",
    position: "relative",
    display: "flex",
    background: "#F4F4F8",
    [theme.breakpoints.down("360")]: {
      padding: "16px 24px",
    },
  },
  configs: {
    padding: "36px",
    [theme.breakpoints.down("360")]: {
      padding: "36px 14px",
    },
  },
}));

export default function Home() {
  const classes = useStyles();
  const { data, isLoading } = useGetConfig();

  return (
    <Box style={{ background: "#fff" }}>
      <Box className={classes.topBox}>
        <img
          src={process.env.PUBLIC_URL + "/assets/images/icons/sheet.svg"}
          alt="kiamia-shop"
        />
        <Typography variant="h3" mr={1}>
          برای دسترسی به فاکتور ها گزینه مورد نظر خود را انتخاب کنید.
        </Typography>
      </Box>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Box className={classes.configs}>
          {data?.result.map(({ ...otherProps }, index) => (
            <GetConfigItem key={index} {...otherProps}></GetConfigItem>
          ))}
        </Box>
      )}
    </Box>
  );
}
